<template>
  <section v-show="false" class="post-section">
    <el-form :model="ruleForm" ref="ruleForm" label-position="top" class="post-form">
      <el-form-item>
        <template slot="label">
          <b>Valor Declarado (Seguro)</b>
          <br />
          <small>Valor entre {{ minData }} e {{ maxData }}</small>
        </template>
        <input
          type="text"
          class="el-input__inner"
          v-model="ruleForm.value"
          @blur="check"
          v-money.lazy="money"
          ref="money"
        />
        <el-alert
          class="alert-title"
          show-icon
          title="Informe um valor para garantir o seguro da sua carga"
          type="info"
        >
        </el-alert>
      </el-form-item>
    </el-form>
  </section>
</template>
<script>
import MoneyMixins from "../../../../xpost/mixins/money";
export default {
  mixins: [MoneyMixins],
  name: "PostDeclaredValue",
  props: ["min", "max"],
  computed: {
    valueData() {
      if (isNaN(+this.ruleForm.value))
        return +this.ruleForm.value.replace("R$", "").replace(/\./g, "").replace(",", ".");
      return +this.ruleForm.value / 100;
    },
    minData() {
      if (+this.min == 0) return "R$ 24,50";
      return Intl.NumberFormat("pt-br", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }).format(this.min);
    },
    maxData() {
      if (+this.max == 0) return "R$ 30.000,00";
      return Intl.NumberFormat("pt-br", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }).format(this.max);
    },
  },
  data() {
    return {
      ruleForm: {
        value: "R$ 0,00",
      },
    };
  },
  methods: {
    setup(form, data) {
      this.ruleForm.value = +form.valuedeclared * 100;
      this.check();
    },
    check() {
      if (this.valueData > 0) {
        if (this.valueData < this.min) {
          this.ruleForm.value = Intl.NumberFormat("pt-br", {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
          }).format(this.min);
        } else if (this.valueData > this.max) {
          this.ruleForm.value = Intl.NumberFormat("pt-br", {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
          }).format(this.max);
        }
      }
    },
  },
};
</script>
